import { render, staticRenderFns } from "./remote-work.vue?vue&type=template&id=bd8f1f4c&scoped=true&"
import script from "./remote-work.vue?vue&type=script&lang=js&"
export * from "./remote-work.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8f1f4c",
  null
  
)

export default component.exports